import { createContext } from "react";
import { ToastNotification } from "@/components/ui/Toast";

export interface ToastContextType {
  notifications: ToastNotification[];
  addToast: (toast: Omit<ToastNotification, "id">) => string;
  removeToast: (id: string) => void;
  clearAllToasts: () => void;
}

export const ToastContext = createContext<ToastContextType | null>(null);
